/**
 * This is the memword service.
 * @memberOf memword Module
 * @namespace memword Service
 */

/**
 * @name memwordService
 * @desc Create the service.
 * @param $q
 * @param memwordDataService
 * @memberOf memword Module memword Service
 * @ngInject
 */
function memwordFactory($q, memwordDataService) {
    // Create the service.
    var service = {};
    return service;

}

export default memwordFactory;



// WEBPACK FOOTER //
// ./src/login/memword/memword.service.js